module.exports = __webpack_public_path__ + "static/media/WhatIsCulture_5.9832d2b7.png";